import { useTranslation } from 'next-i18next';
import React, { useContext, useEffect, useState, VFC } from 'react';

import getTagsByName from '@/apis/aniftyBackend/tags/getTagsByName';
import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import ChevronRight2 from '@/icons/chevron-right2.svg';

import styles from './TagSearchBar.module.scss';

type Props = {
  isShowingNFTs: boolean;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
};

// const tagSelectorColors = [
//   styles.tagSelectorColor1,
//   styles.tagSelectorColor2,
//   styles.tagSelectorColor3,
//   styles.tagSelectorColor4,
//   styles.tagSelectorColor5,
// ];

const TagSearchBar: VFC<Props> = ({ isShowingNFTs, searchTerm, setSearchTerm }: Props) => {
  const { t } = useTranslation();
  const searchCondition = isShowingNFTs
    ? useContext(MarketplaceItemsContext).searchConditionNFTs
    : useContext(MarketplaceItemsContext).searchConditionUsers;
  const setSearchCondition = isShowingNFTs
    ? useContext(MarketplaceItemsContext).setSearchConditionNFTs
    : useContext(MarketplaceItemsContext).setSearchConditionUsers;
  const [searchResults, setSearchResults] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [searchBarIsOnFocus, setSearchBarIsOnFocus] = useState(false);
  const [inSearchModal, setInSearchModal] = useState(false);
  const { i18n } = useTranslation();

  // Search Logic
  useEffect(() => {
    // if dependency changes multiple times in the 1 sec, useEffect only runs the last dependency
    const delaySearch = setTimeout(async () => {
      let results = await getTagsByName(searchTerm);
      if (searchTerm === "" && i18n.language === 'ja') {
        results = results.map(e => ({...e, language: 'JA'}));
      }
      setSearchResults(results);
    }, 1000);
    return () => clearTimeout(delaySearch);
  }, [searchTerm]);

  const keyPress = async (e) => {
    if (e.key === 'Enter') {
      setSearchResults(await getTagsByName(searchTerm));
    }
  };

  const addOrRemoveTag = (tagName: string, tagNameJA: string) => {
    let newTagNames;
    let newTagNamesJA;
    if (searchCondition.tagNames.includes(tagName)) {
      newTagNames = searchCondition.tagNames.filter((item) => item !== tagName);
      newTagNamesJA = searchCondition.tagNamesJA.filter(
        (item) => item !== tagNameJA
      );
    } else {
      newTagNames = [...searchCondition.tagNames, tagName];
      newTagNamesJA = searchCondition.tagNamesJA
        ? [...searchCondition.tagNamesJA, tagNameJA]
        : (newTagNamesJA = [tagNameJA]);
    }

    const newSearchCondition = {
      ...searchCondition,
      tagNames: newTagNames,
      tagNamesJA: newTagNamesJA,
    };
    setSearchCondition(newSearchCondition as any);
  };

  return (
    <div
      className={[styles.sidebarSubsection, styles.tagSearchBarWrapper].join(
        ' '
      )}
    >
      <div className={styles.title}>{t('filterSidebar.tag.heading')}</div>
      <ChevronRight2
        className={
          isCollapsed ? styles.collapseButton : styles.collapseButtonClicked
        }
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      />
      {!isCollapsed && (
        <div>
          <input
            className={styles.tagSearchBar}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={keyPress}
            placeholder={t('filterSidebar.tag.searchbar')}
            onFocus={() => setSearchBarIsOnFocus(true)}
            onBlur={() => setSearchBarIsOnFocus(false)}
            value={searchTerm}
          />
          {(searchBarIsOnFocus || inSearchModal) && (
            <div
              className={styles.tagSearchModal}
              onMouseLeave={() => setInSearchModal(false)}
              onMouseEnter={() => setInSearchModal(true)}
            >
              {searchResults.map((i, index) => (
                <div
                  className={styles.tagResultItem}
                  key={`tag_${index}`}
                  onClick={() => addOrRemoveTag(i.name, i.nameJA)}
                >
                  <span className={styles.searchResultText}>{`${
                    i.language === 'JA' ? i.nameJA : i.name
                  }`}</span>
                </div>
              ))}
              {searchResults.length === 0 && <div>{t('filterSidebar.searchbar.noResult')}</div>}
            </div>
          )}
          {/* <div className={styles.tagList}>
            {searchResults.map((tag) => (
              <div
                className={`${styles.tag} ${
                  tagSelectorColors[pseudoRandom(tag, 0, 4)]
                }`}
                onClick={() => addOrRemoveTag(tag.name, tag.nameJA)}
                key={tag.name}
              >
                {tag.name}
              </div>
            ))}
          </div> */}
        </div>
      )}
    </div>
  );
};
//from here
export default TagSearchBar;
